import React, { useCallback, useContext } from 'react';
import { Helmet } from 'react-helmet';
import MoodDashboard from './MoodDashboard';
import { SidebarContext } from '../../../../context/SidebarContext';
import { useCompanySectionFilter } from '../../../../component/B2B/CompanySectionLayout';
import { fetchCompanyMoodDashboard } from './companyMoodApi';

/** Company Mood Tracking → Dashboard, scoped to this company. */
const CMoodDashboard = () => {
  const { isB2BFansMode } = useContext(SidebarContext);
  const { department } = useCompanySectionFilter();

  const fetcher = useCallback(
    () => fetchCompanyMoodDashboard(department),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isB2BFansMode, department]
  );

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Mood Tracking | Shoorah</title>
      </Helmet>
      <MoodDashboard fetcher={fetcher} populationLabel={isB2BFansMode ? 'members' : 'employees'} />
    </div>
  );
};

export default CMoodDashboard;
